import { render } from "./ContentHeader.vue?vue&type=template&id=5c93ee80&scoped=true"
const script = {}

import "./ContentHeader.vue?vue&type=style&index=0&id=5c93ee80&lang=scss&scoped=true"

import exportComponent from "/opt/gitea/webhooker/hooks/dscontrol/kraken/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c93ee80"]])

export default __exports__